import React, { useEffect, useState } from 'react'
// import Styles from './style/home.module.scss'
import Styles from '../style/rewardingMission.module.scss'
import CategoriesReward from '../component/CategoriesReward'
import TrendingReward from '../component/TrendingReward'
import Fav from '../../../../assets/theme6/fav.svg'
import { Link } from 'react-router-dom'
import Heart from '../../../../assets/theme6/heart.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import BackArrow from '../../../../assets/svg/BackArrow';
import QuizWallicon from '../../../../assets/svg/QuizWallicon';
import BottomBar from '../component/BottomBar'


const MissionReward = () => {
  window.scrollTo(0, 0);
  const navigate = useNavigate()
  const [categoryId, setCategoryId] = useState("all");
  const handleCategoryId = (e) => {
    setCategoryId(e)
  }

  return (
    <>
      <div className={Styles.container_rewarding_mission}>
        <div className={Styles.challenge_box_container_top}>
          <div className={Styles.icon_box}>
            <div onClick={() => navigate(-1)}>
              <BackArrow />
            </div>
            <QuizWallicon width={143} height={31} />
          </div>
          <div className={Styles.favorite_box}>
            <Link to={'/favorite-mission-reward'}>
              <img className={Styles.image} src={Fav} />
            </Link>
          </div>
        </div>
        <div className={Styles.challenge_box_container_bottom}>
          <CategoriesReward setCategoryId={handleCategoryId} />
          <TrendingReward categoryId={categoryId} />
          <div className={Styles.bottom_text}>Pick, <br /> Play & <span className={Styles.color_text}>Earn!</span></div>
          <div id="bottomDiv" className={Styles.jingle_text}>Made with <img style={{ position: 'relative', top: "5px" }} src={Heart} /></div>
        </div>
        <BottomBar />
      </div>
    </>
  )
}

export default MissionReward;